
// import { useState } from "react";
// import BasicDetailsSection from "./BasicDetailsSection";
// import EducationSection from "./EducationSection";
// import ExperienceSection from "./ExperienceSection";
// import ProjectsSection from "./ProjectsSection";
// import SkillsSection from "./SkillsSection";

// const sections = [
//   { key: "basic", label: "Basic Details" },
//   { key: "projects", label: "Projects" },
//   { key: "skills", label: "Skills" },
//   { key: "experience", label: "Experience" },
//   { key: "education", label: "Education" },
// ];

// const ProfilePage = () => {
//   const [formData, setFormData] = useState({
//     basic: {},
//     projects: [],
//     skills: [],
//     experience: [],
//     education: [],
//   });

//   const [isEditMode, setIsEditMode] = useState(true);
//   const [showMobileMenu, setShowMobileMenu] = useState(false);

//   const scrollToSection = (id) => {
//     const section = document.getElementById(id);
//     if (section) {
//       section.scrollIntoView({ behavior: "smooth" });
//       setShowMobileMenu(false); // Close menu after selection
//     }
//   };

//   const handleSave = () => {
//     fetch("https://jsonplaceholder.typicode.com/posts", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(formData),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         alert("Data saved successfully!");
//         console.log("Saved Data:", data);
//         setIsEditMode(false);
//       })
//       .catch((error) => {
//         alert("Error saving data!");
//         console.error("Error:", error);
//       });
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-4 md:p-6 flex flex-col gap-6">
//       {/* Mobile Dropdown Menu */}
//       <div className="md:hidden block bg-white p-4 rounded-xl shadow-md sticky top-0 z-20">
//         <button
//           onClick={() => setShowMobileMenu((prev) => !prev)}
//           className="w-full bg-blue-600 text-white py-2 px-4 rounded-md font-medium"
//         >
//           {showMobileMenu ? "Close Menu" : "Go to Section"}
//         </button>
//         {showMobileMenu && (
//           <div className="mt-4 flex flex-col space-y-2">
//             {sections.map((section) => (
//               <button
//                 key={section.key}
//                 onClick={() => scrollToSection(section.key)}
//                 className="text-left w-full px-3 py-2 rounded-lg hover:bg-blue-100 text-gray-800 font-medium transition"
//               >
//                 {section.label}
//               </button>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Main Layout */}
//       <div className="flex flex-col md:flex-row gap-6">
//         {/* Sidebar for Desktop */}
//         <aside className="hidden md:block md:w-60 bg-white p-6 rounded-2xl shadow-md sticky top-6 h-fit">
//           <nav className="flex flex-col space-y-4">
//             {sections.map((section) => (
//               <button
//                 key={section.key}
//                 onClick={() => scrollToSection(section.key)}
//                 className="text-left px-4 py-2 rounded-lg font-medium hover:bg-blue-100 text-gray-700"
//               >
//                 {section.label}
//               </button>
//             ))}
//           </nav>
//         </aside>

//         {/* Main Content */}
//         <main className="flex-1 bg-white rounded-2xl shadow-xl p-4 md:p-10 max-h-[80vh] overflow-y-auto space-y-12 scroll-smooth">
//           <section id="basic">
//             <BasicDetailsSection
//               formData={formData}
//               setFormData={setFormData}
//               isEditMode={isEditMode}
//             />
//           </section>

//           <section id="projects">
//             <ProjectsSection
//               formData={formData}
//               setFormData={setFormData}
//               isEditMode={isEditMode}
//             />
//           </section>

//           <section id="skills">
//             <SkillsSection
//               formData={formData}
//               setFormData={setFormData}
//               isEditMode={isEditMode}
//             />
//           </section>

//           <section id="experience">
//             <ExperienceSection
//               formData={formData}
//               setFormData={setFormData}
//               isEditMode={isEditMode}
//             />
//           </section>

//           <section id="education">
//             <EducationSection
//               formData={formData}
//               setFormData={setFormData}
//               isEditMode={isEditMode}
//             />
//           </section>

//           <div className="flex justify-center pt-6 space-x-4">
//             {isEditMode ? (
//               <button
//                 type="button"
//                 onClick={handleSave}
//                 className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-md transition-all"
//               >
//                 Save
//               </button>
//             ) : (
//               <button
//                 type="button"
//                 onClick={() => setIsEditMode(true)}
//                 className="bg-gray-300 hover:bg-gray-400 text-black font-bold py-3 px-8 rounded-full shadow-md transition-all"
//               >
//                 Edit
//               </button>
//             )}
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;

import { useState } from "react";
import BasicDetailsSection from "./BasicDetailsSection";
import EducationSection from "./EducationSection";
import ExperienceSection from "./ExperienceSection";
import ProjectsSection from "./ProjectsSection";
import SkillsSection from "./SkillsSection";

const sections = [
  { key: "basic", label: "Basic Details" },
  { key: "projects", label: "Projects" },
  { key: "skills", label: "Skills" },
  { key: "experience", label: "Experience" },
  { key: "education", label: "Education" },
];

const ProfilePage = () => {
  const [formData, setFormData] = useState({
    basic: {},
    projects: [],
    skills: [],
    experience: [],
    education: [],
  });

  const [isEditMode, setIsEditMode] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setShowMobileMenu(false);
    }
  };

  const handleSave = () => {
    fetch("https://jsonplaceholder.typicode.com/posts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        alert("Data saved successfully!");
        console.log("Saved Data:", data);
        setIsEditMode(false);
      })
      .catch((error) => {
        alert("Error saving data!");
        console.error("Error:", error);
      });
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-6 text-[17px] leading-relaxed text-gray-800 font-[500]">
      {/* Mobile Dropdown Menu */}
      <div className="md:hidden block bg-white p-4 rounded-xl shadow-md sticky top-0 z-20">
        <button
          onClick={() => setShowMobileMenu((prev) => !prev)}
          className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-semibold text-lg shadow transition"
        >
          {showMobileMenu ? "Close Menu" : "Go to Section"}
        </button>
        {showMobileMenu && (
          <div className="mt-4 flex flex-col space-y-2">
            {sections.map((section) => (
              <button
                key={section.key}
                onClick={() => scrollToSection(section.key)}
                className="text-left w-full px-4 py-2 rounded-lg hover:bg-blue-100 text-gray-900 font-medium text-base"
              >
                {section.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Main Layout */}
      <div className="flex flex-col md:flex-row gap-6">
        {/* Sidebar for Desktop */}
        <aside className="hidden md:block md:w-64 bg-white p-6 rounded-2xl shadow-md sticky top-6 h-fit">
          <nav className="flex flex-col space-y-4">
            <h2 className="text-xl font-bold mb-2 text-gray-700">Sections</h2>
            {sections.map((section) => (
              <button
                key={section.key}
                onClick={() => scrollToSection(section.key)}
                className="text-left px-4 py-2 rounded-lg font-medium hover:bg-blue-100 text-gray-700 text-base transition"
              >
                {section.label}
              </button>
            ))}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 bg-white rounded-3xl shadow-2xl p-4 md:p-10 max-h-[80vh] overflow-y-auto space-y-16 scroll-smooth">
          <section id="basic">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-blue-700">Basic Details</h2>
            <BasicDetailsSection
              formData={formData}
              setFormData={setFormData}
              isEditMode={isEditMode}
            />
          </section>

          <section id="projects">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-blue-700">Projects</h2>
            <ProjectsSection
              formData={formData}
              setFormData={setFormData}
              isEditMode={isEditMode}
            />
          </section>

          <section id="skills">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-blue-700">Skills</h2>
            <SkillsSection
              formData={formData}
              setFormData={setFormData}
              isEditMode={isEditMode}
            />
          </section>

          <section id="experience">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-blue-700">Experience</h2>
            <ExperienceSection
              formData={formData}
              setFormData={setFormData}
              isEditMode={isEditMode}
            />
          </section>

          <section id="education">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-blue-700">Education</h2>
            <EducationSection
              formData={formData}
              setFormData={setFormData}
              isEditMode={isEditMode}
            />
          </section>

          {/* Save/Edit Button */}
          <div className="flex justify-center pt-6 space-x-4">
            {isEditMode ? (
              <button
                type="button"
                onClick={handleSave}
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-10 rounded-full shadow-lg text-lg transition"
              >
                Save
              </button>
            ) : (
              <button
                type="button"
                onClick={() => setIsEditMode(true)}
                className="bg-gray-300 hover:bg-gray-400 text-black font-bold py-3 px-10 rounded-full shadow-md text-lg transition"
              >
                Edit
              </button>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default ProfilePage;
